import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { IMGIX_URL } from '@src/env';

import { TESTIMONIAL_POST_IMG_URL, TESTIMONIAL_VIDEO_URL, TRUSTED_LOGOS } from './constants';

const Journalism = () => {
  return (
    <div className="flex flex-col items-center justify-center py-80">
      <h2 className="m-0 pb-48 text-center font-suisse-works text-headline-sm">
        Companies and Leaders Rely on our Journalism
      </h2>
      <div className="aspect-[16/9] w-full sm:w-[600px] md:w-[750px]">
        <video
          className="h-full w-full"
          poster={TESTIMONIAL_POST_IMG_URL}
          preload="metadata"
          src={TESTIMONIAL_VIDEO_URL}
          controls
          playsInline
        />
      </div>
      <div className="mt-16 flex max-w-[300px] flex-wrap items-center justify-center gap-64 gap-y-16 sm:w-full sm:max-w-full">
        {TRUSTED_LOGOS.map((logo) => (
          <LazyImgixImage
            key={logo.name}
            alt={`${logo.name} logo`}
            className="h-full w-full"
            src={`${IMGIX_URL}/global/subscribe/${logo.name}_Logo.png`}
            sizes={logo.sizes}
            wrapperClassName={logo.className}
          />
        ))}
      </div>
    </div>
  );
};

export default Journalism;
